import { LANGS } from "types/shared"
import { getItemFromLocalStorage } from "utils/localStorage"
import { IState, IUIContext } from "./UIProviderTypes"

export const UI_INITIAL_CONTEXT: IUIContext = {
  modals: {
    webReservationsTimesModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    webReservationsModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    addEditHolidayModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    addAdminEditHolidayModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    holidaysModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    holidaysModalForQappAdmin: {
      isOpened: false,
      data: null,
      id: "",
    },
    addEditEmployeeModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    confirmationModal: {
      isOpened: false,
      data: {
        title: "",
        handleSubmit: () => {},
        handleDeny: () => {},
        content: null,
      },
      id: "",
    },
    googleMapModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    reservationDetailsModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    editReservationDetailsModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    cancelReservationModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    feeHistoryModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    clientReservationsModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    clientAutosModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    clientTransactionsModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    responseModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    refundModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    myGoogleMapsModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    addEditDistrictModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    reservationSettingsModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    reservationCommissionModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    cancelReservationCommissionModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    addLanguageModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    carOnPlaceModal: {
      isOpened: false,
      data: {
        onDeny: () => {},
        onSubmit: () => {},
      },
      id: "",
    },
  },
  toggleModal: () => {},
  lang: (getItemFromLocalStorage("lang") as LANGS) || LANGS.KA,
  languages: [],
  keywords: {
    ka: null,
    en: null,
  },
  handleLanguageChange: () => {},
  T: () => "",
}

export const UI_INITIAL_STATE: IState = {
  modals: {
    webReservationsTimesModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    webReservationsModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    addEditHolidayModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    addAdminEditHolidayModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    holidaysModalForQappAdmin: {
      isOpened: false,
      data: null,
      id: "",
    },
    holidaysModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    addEditEmployeeModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    confirmationModal: {
      isOpened: false,
      data: {
        title: "",
        handleSubmit: () => {},
        handleDeny: () => {},
        content: null,
      },
      id: "",
    },
    googleMapModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    reservationDetailsModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    editReservationDetailsModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    cancelReservationModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    feeHistoryModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    clientReservationsModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    clientAutosModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    clientTransactionsModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    responseModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    refundModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    myGoogleMapsModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    addEditDistrictModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    reservationSettingsModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    reservationCommissionModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    cancelReservationCommissionModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    addLanguageModal: {
      isOpened: false,
      data: null,
      id: "",
    },
    carOnPlaceModal: {
      isOpened: false,
      data: {
        onDeny: () => {},
        onSubmit: () => {},
      },
      id: "",
    },
  },
  lang: (getItemFromLocalStorage("lang") as LANGS) || LANGS.KA,
  languages: [],
  keywords: {
    ka: null,
    en: null,
  },
}
